import React, {useState , useEffect} from 'react'; 
import $ from 'jquery';
import Swal from 'sweetalert2';
import RO_curriculum_page from './RO_curriculum_page';
import RO_Pricing_card from './RO_Pricing_card';
import RO_Review_Program_Page from './RO_Review_Program_Page';
import RO_FAQ_page from './RO_FAQ_page';
import Certificates from '../Certificates';
import Counsellor from '../Counsellor';
import All_Program_Mentor from '../All_Program_Mentor';
import { Helmet } from 'react-helmet-async';
import { SlUser } from 'react-icons/sl'
import { HiOutlinePhone } from 'react-icons/hi'
import { MdOutlineMailOutline } from 'react-icons/md'
import { HiOutlineBuildingLibrary } from "react-icons/hi2";
import { LiaSwatchbookSolid } from "react-icons/lia";
import RO from "../image/RO.avif"
import DemoClass from '../DemoClass';


function RO_page() {
   
  const canonicalUrl = 'https://internselite.net/Robotics';

  useEffect(()=>{
    document.title= 'Robotics | Traineeship Program | InternsElite';
  },[]);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobileNo: '',
    collegeName: '',
    programName: '',
  });

  const [nameError, setNameError] = useState(" "); 
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [collegeError, setCollegeError] = useState("");
  const [programError, setProgramError] = useState("");

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === 'fullName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setNameError(`Invalid name format.`);
      }  
      else {
        setNameError("");
      }
    }
    
    if (name === 'email') {
      if (!value || !/\S+@\S+\.\S+/.test(value)) {
        setEmailError("Invalid email format");
      } else {
        setEmailError("");
      }
    
    }

    if (name === 'mobileNo') {
      if (!value || !/^\d{10}$/.test(value)) {
        setPhoneError("Length Should be 10 Digit");
      } else {
        setPhoneError("");
      }
    }
    if (name === 'collegeName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setCollegeError(`Invalid College Name format.`);
      }  
      else {
        setCollegeError("");
      }
    }   
    if (name === 'programName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setProgramError(`Invalid College Name format.`);
      }  
      else {
        setProgramError("");
      }
    }  
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  

  const handleSubmit = async(event) => {
    event.preventDefault();
    $.ajax({
      url: 'https://forms.internselite.net/traineeship/T5',
      type: 'POST',
      data: {
        fullName: $('[name="fullName"]').val(),
        mobileNo: $('[name="mobileNo"]').val(),
        email: $('[name="email"]').val(),
        collegeName: $('[name="collegeName"]').val(),
        programName: $('[name="programName"]').val()
      },
      success: function (response) {
        Swal.fire({
          title: "Form Submitted!",
          text: "Thank you for your interest in the Traineeship Program! Our counsellor will contact you within 24 hours with the next steps.",
          icon: "success"
        });
        $('[name="fullName"]').val('');
        $('[name="mobileNo"]').val('');
        $('[name="email"]').val('');
        $('[name="collegeName"]').val('');
        $('[name="programName"]').val('');
      },
      error: function (error) {
        console.error('Error:', error);
      }
    });
  };
  return (
    <>
    <style>{`
        .RO_program_details_image{
          background-image: url(${RO});
          background-repeat: no-repeat;
          background-size: cover;
          z-index:-1 !important;
        }
        .RO_program_details_image .background_color{
          background-image: linear-gradient(rgb(7, 7, 7,0.5), rgba(7,7,7,0.7));
          width:100%;
        }
      `}</style>
    <div>
    <Helmet>
        <title>Robotics Course | InternsElite: Learn Robotics from Experts</title>
        <meta name='description' content='Enroll in InternsElite’s Robotics course to learn from industry experts. Gain practical experience in robotics engineering, and earn a professional certification. Advance your career in the innovative field of robotics.' />
        <meta name='keywords' content='robotics, robotics engineering, online training, certification course, professional courses, robotics certificationRobotics course, Robotics classes, Robotics training course, Robotics internship program, Robotics automation course' />
        <meta property="og:title" content="Robotics Course | InternsElite: Learn Robotics from Experts" />
        <meta property="og:description" content="Enroll in InternsElite’s Robotics course to learn from industry experts. Gain practical experience in robotics engineering, and earn a professional certification. Advance your career in the innovative field of robotics." />
        <meta property="og:url" content="https://internselite.net/Robotics" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@internselite" />
        <meta name="twitter:title" content="Robotics Course | InternsElite: Learn Robotics from Experts" />
        <meta name="twitter:description" content="Enroll in InternsElite’s Robotics course to learn from industry experts. Gain practical experience in robotics engineering, and earn a professional certification. Advance your career in the innovative field of robotics." />
        <meta name="twitter:image" content="https://internselite.net/static/media/logo.c1eb8ff81ef75599f376.png" />
        <link rel="canonical" href={canonicalUrl} />
    </Helmet>

    {/* -----------------------Mobile view--------------------- */}
    <div className='RO_program_details_image d-sm-block d-md-none'>
        <div className='container-fluid background_color py-5'>
            <div className='row mt-4'>
              <div className='col-md-12'>
                <div className='Details_Main_text'>
                  <h1 className='display-5 pt-5 text-white'>Robotics Traineeship Program</h1>
                  <h4 className='text-white pt-2'>Start Learning Robotics by Top Industry Experts...</h4>
                  <a href='#RO'><button className="text-white shadow-sm my-4 fs-5 px-4 pt-1 pb-2 Pr_details_button">Read More...</button></a>
              </div>
              </div>
              <div className='col-md-12'>
                <div className='Program_details_form  px-3'>
                    <div className='py-4'>
                    <p className='text-center fs-3'>Apply Now</p>
                    <form onSubmit={handleSubmit}>
                          <div class="mt-2">
                            <label for="fullName" class="pb-2 contact_form"><SlUser size="18px"/>{' '}Full Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="fullName"
                              name="fullName"
                              placeholder="Your answer"
                              value={formData.fullName}
                              onChange={handleInputChange}
                              required
                            />
                            {nameError && <div className="error text-danger">{nameError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="email" class="pb-2 contact_form"><MdOutlineMailOutline size="18px"/>{' '}Email Address</label>
                            <input
                              className='form-control'
                              type="email"
                              id="email"
                              name="email"
                              placeholder="Your answer"
                              value={formData.email}
                              onChange={handleInputChange}
                              required
                            />
                            {emailError && <div className="error text-danger">{emailError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="mobileNo" class="pb-2 contact_form"><HiOutlinePhone size="18px"/>{' '}Phone Number</label>
                            <input
                              className='form-control'
                              type="tel"
                              id="mobileNo"
                              name="mobileNo"
                              placeholder="+91 xxxxxxxxxx"
                              value={formData.mobileNo}
                              onChange={handleInputChange}
                              required
                            />
                            {phoneError && <div className="error text-danger">{phoneError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="collegeName" class="pb-2 contact_form"><HiOutlineBuildingLibrary size="18px"/>{' '}College Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="collegeName"
                              name="collegeName"
                              placeholder="Your answer"
                              value={formData.collegeName}
                              onChange={handleInputChange}
                              required
                            />
                            {collegeError && <div className="error text-danger">{collegeError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="programName" class="pb-2 contact_form"><LiaSwatchbookSolid size="18px"/>{' '}Program</label>
                            <input
                              type="text"
                              readonly class="form-control form-control-plaintext px-2"
                              id="programName"
                              placeholder="Your answer"
                              value="Robotics"
                              required />
                            {programError && <div className="error text-danger">{programError}</div>}
                          </div>
                          
                        <div className='row mt-2 pt-4'>
                          <div className='d-flex justify-content-center'>
                            <button className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button">Submit</button>
                          </div>
                        </div>
                    </form>
                    </div>  
                    </div>
              </div>
            </div>
        </div>
    </div>

    {/* ----------------------Desktop View---------------- */}
    <div className='RO_program_details_image d-none d-md-block mt-5'>
        <div className='container-fluid background_color py-5'>
            <div className='row mt-5'>
              <div className='col-md-7'>
                <div className='px-5 mt-5 pt-5 Details_Main_text'>
                  <h1 className='display-4 mt-5 pt-5 text-white'>Robotics Traineeship Program</h1>
                  <h4 className='text-white  pt-2'>Start Learning Robotics by Top Industry Experts...</h4>
                  <a href='#RO'><button className="text-white shadow-sm my-4 fs-5 px-4 pt-1 pb-2 Pr_details_button">Read More...</button></a>
              </div>
              </div>
              <div className='col-md-5 px-3 pt-2'>
              <div className='container'>
                <div className=''>
                <div className=''>
                <div className='Program_details_form px-5'>
                    <div className='py-4'>
                    <p className='text-center fs-3'>Apply Now</p>
                    <form onSubmit={handleSubmit}>
                          <div class="mt-2">
                            <label for="fullName" class="pb-2 contact_form"><SlUser size="18px"/>{' '}Full Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="fullName"
                              name="fullName"
                              placeholder="Your answer"
                              value={formData.fullName}
                              onChange={handleInputChange}
                              required
                            />
                            {nameError && <div className="error text-danger">{nameError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="email" class="pb-2 contact_form"><MdOutlineMailOutline size="18px"/>{' '}Email Address</label>
                            <input
                              className='form-control'
                              type="email"
                              id="email"
                              name="email"
                              placeholder="Your answer"
                              value={formData.email}
                              onChange={handleInputChange}
                              required
                            />
                            {emailError && <div className="error text-danger">{emailError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="mobileNo" class="pb-2 contact_form"><HiOutlinePhone size="18px"/>{' '}Phone Number</label>
                            <input
                              className='form-control'
                              type="tel"
                              id="mobileNo"
                              name="mobileNo"
                              placeholder="+91 xxxxxxxxxx"
                              value={formData.mobileNo}
                              onChange={handleInputChange}
                              required
                            />
                            {phoneError && <div className="error text-danger">{phoneError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="collegeName" class="pb-2 contact_form"><HiOutlineBuildingLibrary size="18px"/>{' '}College Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="collegeName"
                              name="collegeName"
                              placeholder="Your answer"
                              value={formData.collegeName}
                              onChange={handleInputChange}
                              required
                            />
                            {collegeError && <div className="error text-danger">{collegeError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="programName" class=" pb-2  contact_form"><LiaSwatchbookSolid size="18px"/>{' '}Program</label>
                            <input
                              type="text"
                              readonly class="form-control form-control-plaintext px-2"
                              id="programName"
                              placeholder="Your answer"
                              value="Robotics"
                              required />
                            {programError && <div className="error text-danger">{programError}</div>}
                          </div>
                          
                        <div className='row mt-2 pt-4'>
                          <div className='d-flex justify-content-center'>
                            <button className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button">Submit</button>
                          </div>
                        </div>
                    </form>
                    </div>
                </div>
                </div>
                </div>
              </div>
              </div>
            </div>
        </div>
    </div>

    <div className='py-5' id='RO'><RO_program_details/></div>
    <div className='Curriculum_Containte_box py-5'>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-md-2'></div>
          <div className='col-md-8'>
          <div className='text-center Curriculum_Main_text'>
                <h2 className='display-6 pb-1'>Program Curriculum</h2>
                <p className='px-2'>A comprehensive and dynamic syllabus designed to empower your skills and propel your success in every aspect of your professional and personal development.</p>
            </div>
          </div>
          <div className='col-md-2'></div>
        </div>
        <div className='row'>
          <div className='col-md-1'></div>
          <div className='col-md-10'>
          <div className='mt-3'>
            <RO_curriculum_page/>
          </div>
          <div className='col-md-1'></div>
          </div>
        </div>
      </div>
    </div>

    <Certificates/>
    <RO_Pricing_card/>
    <DemoClass/>
    {/* <All_Program_Mentor/> */}
    <RO_Review_Program_Page/>
    <RO_FAQ_page/>
    <Counsellor/>
    </div>
    </>
  )
}

function RO_program_details(){
  return(
    <>
    <div>
      {/* ---------------------Mobile view-------------------- */}
      <div className="d-sm-block d-md-none">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center Program_details_1stcomp_text_mobile">
                <h2 className="display-6">Practical Robotics Learning for Real Growth</h2>
                <p className="py-2">
                  Dive into the world of robotics with us. Unlock your potential 
                  and build skills for the future. Enrol today and shape your 
                  path in innovation and automation. Open the door to a bright 
                  career with endless opportunities.

                </p>
              </div>
              <div className="mt-4 text-center Program_details_1stcomp_text_mobile">
                <h2 className="display-6">Overview</h2>
                <p className="py-2">
               Take a big step into the world of robotics with our complete program. 
               Learn the laws, types, and key parts of robot design in simple ways. 
               Work with the ATmega 328p microcontroller to connect sensors and actuators. 
               Get hands-on practice programming Arduino devices for stepper, servo, 
               and DC motors. Understand how to use Bluetooth, SPI, and I2C for 
               smooth communication. Explore the power of ROS to create advanced 
               robotic movements. End your journey with a real project that shows your skills. 
               Ignite your passion for robotics and start your path toward innovation.

                </p>
              </div>
            </div>
            <div className="col-md-12">
              <div>
                <div className=" Details_container shadow-lg px-1 py-4">
                  <h3 className="Details_text text-center  pb-2 border-bottom">
                    Robotics
                  </h3>
                  <div className="Details_text">
                    <ul className="pt-2">
                     <li>Learn from live expert sessions with industry professionals</li>
                    <li className="py-3">Project support and guidance</li>
                    <li>Access exclusive program material </li>
                    <li className="py-3">25+ learning hours</li>
                    <li>
                      Certification to boost your career profile and achieve growth & success                     
                    </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---------------------------Desktop View----------------- */}
      <div className="d-none d-md-block">
        <div className="container">
          <div className="row">
            <div className="col-md-8 detail_1stcomp_img">
              <div className="pt-3 Program_details_1stcomp_text">
                <h2 className="fs-2"> Practical Robotics Learning for Real Growth</h2>
                <p className="py-2">
                 Dive into the world of robotics with us. Unlock your 
                 potential and build skills for the future. Enrol today 
                 and shape your path in innovation and automation. 
                 Open the door to a bright career with endless opportunities.

                </p>
              </div>
              <div className="mt-3 Program_details_1stcomp_text">
                <h2 className="display-6">Overview</h2>
                <p className="py-2">
                 Take a big step into the world of robotics with our 
                 complete program. Learn the laws, types, and key parts 
                 of robot design in simple ways. Work with the ATmega 328p 
                 microcontroller to connect sensors and actuators. 
                 Get hands-on practice programming Arduino devices for stepper, 
                 servo, and DC motors. Understand how to use Bluetooth, SPI, 
                 and I2C for smooth communication. Explore the power of ROS to 
                 create advanced robotic movements. End your journey with a real 
                 project that shows your skills. Ignite your passion for robotics 
                 and start your path toward innovation.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div>
                <div className=" Details_container shadow-lg px-3 py-4">
                  <h3 className="Details_text text-center  pb-4 pt-3 border-bottom">
                    Robotics
                  </h3>
                  <div className="Details_text ">
                    <ul className="pt-3">
                       <li>Learn from live expert sessions with industry professionals</li>
                    <li className="py-3">Project support and guidance</li>
                    <li>Access exclusive program material </li>
                    <li className="py-3">25+ learning hours</li>
                    <li>
                      Certification to boost your career profile and achieve growth & success                     
                    </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default RO_page
